<template>
  <div>
    <router-link
      class="cursor-pointer font-bold"
      :to="{ 
        name: 'mark-list', 
        params: {
          class_id: params.colDef.CellRendererParams.class_id,
          student_id: params.data.client_user_id,
          student_name: params.data.student_name,
          class_name: params.data.class_name,
          session_name: params.data.class_term,
          user_class_answer_master_id: params.data.id,
          edit_permission: params.colDef.CellRendererParams.permissions
        },
        query: {
          is_archived: params.colDef.CellRendererParams.is_archived
        }
      }"
    >
      Marks Entry
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'MarksEntryCell'
}
</script>